export interface NavigationState {
  currentProductUuid: string | null;
  currentCategory: string | null;
  isLoading: boolean;
}

export const initialNavigationState: NavigationState = {
  currentProductUuid: null,
  currentCategory: null,
  isLoading: false,
};
